<template>
    <div class="search_bar__app-search-input">
        <input
            v-model="query"
            type="search"
            name="search_query"
            class="search-bar__input search-bar__mobile brekz-form-control"
            :placeholder="$t('algoliaSearch.searchBarInputPlaceholderApp')"
            aria-label="Type your search here"
            @keyup.enter="$event.target.blur()"
        />
        <span class="search-bar__close search-bar__close--app" v-show="query.length > 0" @click="query = ''">
            <i class="far fa-times"></i>
        </span>
        <span class="search-bar__button--mobile hidden-lg-up" v-show="query.length === 0">
            <i class="fa fa-search" aria-hidden="true"></i>
        </span>
        <svg class="brekz-header__search-spin-mobile js-brekz-header__search-spin-mobile" style="display: none; right: 1.3rem;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle style="opacity: .25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path style="opacity: .75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    </div>
</template>

<script>
export default {
    name: "AlgoliaSearchInputApp",
    props: {
        device: {
            required: false,
            default: false,
            type: String
        },
        pageName: {
            type: [String, Number],
            required: false
        }
    },
    data() {
        return {
            query: ""
        };
    },
    mounted() {
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has("query")) {
            this.query = searchParams.get("query");
        }
    },
    watch: {
        query(newValue) {
            const urlClass = new URL(document.location);
            if (newValue !== "") {
                urlClass.searchParams.set("query", newValue);
            } else {
                urlClass.searchParams.delete("query");
            }
            const url = urlClass.toString();

            if (history.pushState) {
                window.history.pushState({ path: url }, "", url);
            }
            EventBus.$emit("search-input-hit", newValue);
        }
    },
    methods: {
        hitSearch() {
            EventBus.$emit("search-input-hit", value);
        },
        removeSearch() {
            this.query = "";
            EventBus.$emit("search-input-hit", "");
        }
    }
};
</script>
